export function removeSpecialCharacters(val) {
    if (typeof val != "string") return "";
    return val.replace(/[^\w\s]/gi, "");
}

export function matchRule(str, rule) {
    // TODO: Possibly unnecessary escape characters in Regex
    // eslint-disable-next-line no-useless-escape
    var escapeRegex = str => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(str);
}